import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  InputLabel,
  MenuItem,
  Select,
  FormControl,
} from "@mui/material";
import { styled } from "@mui/system";
import toast from "react-hot-toast";

const FormWrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  maxWidth: "600px",
  margin: "auto",
  padding: "16px",
  border: "1px solid #ccc",
  borderRadius: "8px",
});

const ToolInputForm = () => {
  const [formData, setFormData] = useState({
    toolName: "",
    driveLink: "",
    description: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const role = sessionStorage.getItem("role");
  const token = sessionStorage.getItem("accesstoken");

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form Data:", formData);

    const url = "https://rohan-tax-services.onrender.com/api/auth/addtool";

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${token}`,
      },
      body: JSON.stringify({
        role: role,
        name: formData.toolName,
        description: formData.description,
        link: formData.driveLink,
      }),
    });

    if (response) {
      const data = await response.json();
      const msg = data.msg;
      if (response.status === 200) {
        toast.success(msg);
        setFormData({
          toolName: "",
          description: "",
          driveLink: "",
        });
      } else {
        toast.error(msg);
      }
    }
  };

  return (
    <div>
      <FormWrapper
        component="form"
        onSubmit={handleSubmit}
        className="bg-white"
        sx={{
          padding: { xs: 2, sm: 3, md: 4 }, // Responsive padding
          width: { xs: "100%", sm: "80%", md: "60%" }, // Responsive width
          margin: "0 auto", // Center the form horizontally
          borderRadius: 2,
        }}
      >
        <Typography variant="h5" textAlign="center" className="py-4">
          Create Tool
        </Typography>

        <TextField
          label="Tool Name"
          name="toolName"
          value={formData.toolName}
          onChange={handleChange}
          fullWidth
          required
          className="bg-gray-50"
          sx={{ my: 1 }}
        />

        <TextField
          label="Drive Link"
          name="driveLink"
          value={formData.driveLink}
          onChange={handleChange}
          fullWidth
          required
          className="bg-gray-50"
          sx={{ my: 1 }}
        />

        <TextField
          label="Description"
          name="description"
          value={formData.description}
          onChange={handleChange}
          multiline
          rows={4}
          fullWidth
          required
          className="bg-gray-50"
          sx={{ my: 1 }}
        />

        <div>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            sx={{ width: "100px", float: "right" }}
          >
            Submit
          </Button>
        </div>
      </FormWrapper>
    </div>
  );
};

export default ToolInputForm;
